import HeaderDetailStyled from "components/OrderDetail/HeaderDetail/HeaderDetail.styled"
import Skeleton from "react-loading-skeleton"
import { OderType, OrderShippingType } from "types/OrderType"
import { formatAdvanceDate } from "helpers/FormatDateHelper"

const ContractorHeaderDetail = ({ order, sg }: { order: OderType; sg: OrderShippingType }) => {
  const formatString = "dd-MM-yyyy HH:mm"

  return (
    <HeaderDetailStyled>
      <div className="header-oder-info">
        {order?.customer?.id && <p>{order?.customer?.id || <Skeleton width={200} />} </p>}
        {sg?.currentStatus?.date && (
          <p>
            Fecha de estado actual:{" "}
            {formatAdvanceDate(sg?.currentStatus?.date, formatString) || <Skeleton width={200} />}
          </p>
        )}
      </div>
      <div className="header-oder-info">
        {order?.channel ? (
          <p className="field">
            <span>Canal:</span>
            <span className="relevant-title">{order.channel}</span>
          </p>
        ) : (
          <p>
            <Skeleton width={200} />
          </p>
        )}
      </div>
    </HeaderDetailStyled>
  )
}

export default ContractorHeaderDetail
